import z from 'zod'

import { fetchStrapiApp } from '@/src/domains/strapi/services/fetchStrapiApp'

const CMSServicePagesSchema = z.object({
  customServicePages: z.array(
    z.object({
      serviceId: z.number(),
      page: z.object({
        slug: z.string(),
      }),
    }),
  ),
})

export const getHeaderServicesPagesSWRKey = () => {
  return 'header-services-pages'
}

export async function fetchHeaderServicesPages() {
  const res = await fetchStrapiApp({
    query: {
      populate: { customServicePages: { fields: ['serviceId'], populate: { page: { fields: ['slug'] } } } },
    },
    schema: CMSServicePagesSchema,
  })

  const { customServicePages } = res

  return customServicePages.reduce<Record<number, string>>((acc, { serviceId, page }) => {
    acc[serviceId] = page.slug
    return acc
  }, {})
}
